import classNames from "classnames"
import { WearableModalType } from "../types"
import WearableContentInfo from "../WearableContentInfo"
import { Icon, IconColor } from "@/components/shared/Icon"
import { getBatteryChargeIcon } from "@/utils/index"

type WearableAlreadyAssignedInfoProps = {
   wearableId: string
   batteryPercentage?: number | null
}

const WearableAlreadyAssignedInfo = ({
   wearableId,
   batteryPercentage,
}: WearableAlreadyAssignedInfoProps) => {
   return (
      <WearableContentInfo
         type={WearableModalType.ALREADY_ASSIGNED}
         description={
            <div
               className={classNames(
                  "wearable-content-info__description",
                  "wearable-content-info__description--already-assigned"
               )}
            >
               ReassureBand <span> {wearableId} </span>
               {batteryPercentage != null && (
                  <span className="wearable-content-info__battery">
                     <Icon
                        name={getBatteryChargeIcon(batteryPercentage)}
                        color={IconColor.WHITE}
                        size="16"
                     />
                     <span>{batteryPercentage}%</span>
                  </span>
               )}{" "}
               is already assigned to another inmate. Please scan or select a
               different ReassureBand.
            </div>
         }
      />
   )
}

export default WearableAlreadyAssignedInfo
